<template>
<div class="bg-white px-4 pb-4">
    <div class="justify-between items-center flex md:flex-row flex-col gap-4 w-full pb-4">
        <div class="flex flex-col pt-4">
            <h1 class="h6 pl-1">
                <slot name="title" />
            </h1>
            <slot name="breadcrumb" />
        </div>

        <div class="">
            <slot name="actions" />
        </div>
    </div>
    <slot />
</div>
</template>

<script setup>
import { onMounted, watch } from 'vue';
import { useTheme } from 'vuetify';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';

const theme = useTheme();
const { profile } = storeToRefs(useUserStore());

const applyTheme = () => {
    if (profile.value) {
        const themeName = theme.global.name.value;
        if (profile.value.primary_color) {
            theme.themes.value[themeName].colors.primary = profile.value.primary_color;
        }
        if (profile.value.secondary_color) {
            theme.themes.value[themeName].colors.secondary = profile.value.secondary_color;
        }
    }
};

onMounted(() => {
    applyTheme();
});

// Also watch for profile changes
watch(profile, () => {
    applyTheme();
}, { immediate: true });
</script>

<script>
// Use a separate normal script tag for options
export default {
    inheritAttrs: false
};
</script>
